import './RelatedLink.scss';

import cn from 'classnames';
import React from 'react';

import Button from '@/common/components/atoms/Button/Button';
import scrollToAnchor from '@/common/helpers/scrollToAnchor';
import { ReactComponent as ArrowAnchor } from '@/ebat/assets/icons/arrow-bold-bottom.svg';

import {
  RelatedLinkDefaultProps,
  RelatedLinkPropTypes,
} from './RelatedLink.proptypes';

const RelatedLink = ({ anchor, className, label, title }) => (
  <div className={cn('related-link', className)} data-qa-id="related-link">
    {title && <p className="title">{title}</p>}
    <Button
      className="link"
      context="related-link"
      onClick={() => scrollToAnchor(anchor)}
    >
      <span className="label">{label}</span>
      <ArrowAnchor className="button__icon" />
    </Button>
  </div>
);

RelatedLink.defaultProps = {
  ...RelatedLinkDefaultProps,
};

RelatedLink.propTypes = {
  ...RelatedLinkPropTypes,
};

export default RelatedLink;
